import React, { useEffect, useState } from 'react';
import { Card, Button, Form, Input, Select, message, Row, Col, Spin } from 'antd';
import { useNavigate, useParams } from 'react-router-dom'; // Import useParams
import axios from '../util/axiosConfig';
import '../styles/common.css';
const { Option } = Select;

const ToleranceUpdate: React.FC = () => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>(); // Get ID from URL params
    const [poDocType, setDocumentlist] = useState<any[]>([]);
    const [inputErrorMessage, setInputErrorMessage] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const [valueList, setValueList] = useState<any[]>([]);
    const [selectedValueType, setSelectedValueType] = useState<number | undefined>(undefined);
    // const [valueTypeErrorMessage, setValueTypeErrorMessage]
    //  = useState<string | null>(null);

    useEffect(() => {
        fetchDocumentList();
        fetchValueTypeList();
        if (id) {
            fetchToleranceDetails(id); // Fetch details if ID exists
        }
    }, [id]);

    // Fetch all document types
    const fetchDocumentList = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`/po-document-type/get-all-po-document-type`);
            setDocumentlist(response?.data?.data || []);
        } catch (error) {
            console.error('Failed to fetch document types:', error);
        }
        setLoading(false);
    };

    // Fetch all value types
    const fetchValueTypeList = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`/po-document-type/get-all-value-type`);
            setValueList(response?.data?.data || []);
        } catch (error) {
            console.error('Failed to fetch value types:', error);
        }
        setLoading(false);
    };

    // Fetch specific tolerance details based on the given ID
    const fetchToleranceDetails = async (docTypeId: string) => {
        setLoading(true);
        try {
            const response = await axios.get(`/po-document-type/get-document-type-id`, {
                params: { id: docTypeId }
            });

            if (response?.data?.data) {
                const toleranceData = response.data.data;
                form.setFieldsValue({
                    docType: toleranceData.id,
                    valueType: toleranceData.valueTypeId,
                    percentage: toleranceData.percentageTolerance || '',
                    value: toleranceData.valueTolerance || '',
                });

                setSelectedValueType(toleranceData.valueTypeId);
            }
        } catch (error) {
            console.error('Failed to fetch tolerance details:', error);
        }
        setLoading(false);
    };

    const handleDocTypeChange = (value: any) => {
        const doc = poDocType.find((doc) => doc.id === value);
        // setSelectedValueType(doc?.valueTypeId ?? null);
        form.setFieldsValue({
            valueType: doc?.valueTypeId || null,
            percentage: doc?.percentageTolerance ?? '',
            value: doc?.valueTolerance ?? '',
        });
    };

    // const handleValueTypeChange = (value: any) => {
    //     setSelectedValueType(value);
    //     if (!value) {
    //         setValueTypeErrorMessage('
    // Please Select the Value type.');
    //         return
    //     } else {
    //         setValueTypeErrorMessage(null)
    //     }
    // };

    const handleModNaviate = () => {
        navigate(`/tolerance-modificationlog/${id}`);
    };

    const handleInputChange = (field: 'percentage' | 'value', val: string) => {
        const newValue = val ? parseFloat(val) : undefined;

        // Get current values from form
        const currentPercentage = form.getFieldValue('percentage');
        const currentValue = form.getFieldValue('value');

        // Validation logic
        if (!newValue && !currentPercentage && !currentValue) {
            form.setFields([
                { name: 'percentage', errors: ['At least one field (Percentage or Value) must be filled.'] },
                { name: 'value', errors: ['At least one field (Percentage or Value) must be filled.'] }
            ]);
        } else if (currentPercentage && currentValue) {
            form.setFields([
                { name: 'percentage', errors: ['Only one field (Percentage or Value) should be filled.'] },
                { name: 'value', errors: ['Only one field (Percentage or Value) should be filled.'] }
            ]);
        } else {
            form.setFields([
                { name: 'percentage', errors: [] },
                { name: 'value', errors: [] }
            ]);
        }
        form.setFieldsValue({ [field]: newValue });
    };

    const handleSubmit = async (values: any) => {
        if (!values.percentage && !values.value) {
            form.setFields([
                { name: 'percentage', errors: ['At least one field (Percentage or Value) must be filled.'] },
                { name: 'value', errors: ['At least one field (Percentage or Value) must be filled.'] }
            ]);
            return;
        } else if (values.percentage && values.value) {
            form.setFields([
                { name: 'percentage', errors: ['Only one field (Percentage or Value) should be filled.'] },
                { name: 'value', errors: ['Only one field (Percentage or Value) should be filled.'] }
            ]);
            return;
        } else {
            form.setFields([
                { name: 'percentage', errors: [] },
                { name: 'value', errors: [] }
            ]);
        }

        try {
            const response = await axios.put('/po-document-type/update-po-document-type', {}, {
                params: {
                    id: values.docType,
                    valueTypeId: values.valueType || null,
                    percentageTolerance: values?.percentage !== undefined ? values.percentage : '',
                    valueTolerance: values?.value !== undefined ? values.value : '',
                },
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (response.status === 200) {
                message.success('Tolerance updated successfully');
                setTimeout(() => {
                    window.location.href = '/tolerance-list';
                }, 1000);
            } else {
                message.error('Failed to submit Tolerance');
            }
        } catch (error) {
            message.error('Error occurred while submitting Tolerance');
        }
    };

    return (
        <>
            {loading ? (
                <div className="spin-container">
                    <Spin size='default' /><span style={{ marginLeft: '7px' }}>Loading...</span>
                </div>
            ) :
                <Card bordered={false} title={'Tolerance'}
                    extra={
                        <Button onClick={handleModNaviate}>
                            Modificatin Log
                        </Button>
                    }
                >
                    <Row>
                        <Col span={10}>
                            <Form form={form} layout="vertical" onFinish={handleSubmit}>

                                <Form.Item
                                    name="docType"
                                    label="Document Type"
                                    rules={[{ required: true, message: 'Please select the Document type.' }]}
                                >
                                    <Select placeholder="Select Document type" showSearch onChange={handleDocTypeChange} optionFilterProp="name" >
                                        {poDocType?.map((Document) => (
                                            <Select.Option key={Document.id} value={Document.id} name={Document.docType} >
                                                {Document.docType}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>

                                <Form.Item
                                    name="valueType"
                                    label="Value Type"
                                    rules={[{ required: true, message: 'Please select the Value type.' }]}
                                >
                                    <Select placeholder="Select Value type">
                                        {valueList?.map((Document) => (
                                            <Option key={Document.id} value={Document.id}>
                                                {Document.type}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>

                                {/* <div className='user_selectfields'>
                                <span className='requiredStar'>* </span><label className='userSelectLabels'>Value Type</label>
                                <Select placeholder="Select Value type" value={selectedValueType} onChange={handleValueTypeChange}>
                                    {valueList?.map((Document) => (
                                        <Option key={Document.id} value={Document.id}>
                                            {Document.type}
                                        </Option>
                                    ))}
                                </Select>
                                {valueTypeErrorMessage && <div style={{ color: 'red', marginTop: 5 }}>{valueTypeErrorMessage}</div>}
                            </div> */}

                                <Form.Item name="percentage" label="Percentage" style={{ marginBottom: '0px' }}>
                                    <Input type='number' onChange={(e) => handleInputChange('percentage', e.target.value)} />
                                </Form.Item>
                                {inputErrorMessage && <div style={{ color: 'red', marginTop: 5 }}>{inputErrorMessage}</div>}

                                <Form.Item name="value" label="Value" style={{ marginTop: 24 }}>
                                    <Input type='number' onChange={(e) => handleInputChange('value', e.target.value)} />
                                </Form.Item>

                                <Form.Item>
                                    <Button type="primary" htmlType="submit">
                                        Update
                                    </Button>
                                    <Button onClick={() => navigate('/tolerance-list')} style={{ marginLeft: 8 }}>
                                        Cancel
                                    </Button>
                                </Form.Item>
                            </Form>
                        </Col>
                    </Row>
                </Card>
            }
        </>
    );
};

export default ToleranceUpdate;